export default __webpack_public_path__ + "static/media/pinpointLocationMonitoring.f1b043c0.png";